import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './TextAreaModule.module.scss';

export interface TextAreaProps {
	className?: string;
	rows?: number;
	value?: string;
	onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
	hasError?: boolean;
	disabled?: boolean;
	charactersLimit?: number;
	placeholder?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({
		className,
		rows = 3,
		onChange,
		value,
		hasError = false,
		disabled,
		charactersLimit,
		placeholder,
	}: TextAreaProps) => (
		<textarea
			className={joinClasses([
				styles.textArea,
				className,
				hasError ? styles.invalid : undefined,
			])}
			rows={rows}
			value={value}
			onChange={onChange}
			disabled={disabled}
			maxLength={charactersLimit}
			placeholder={placeholder}
		/>
	),
);

export default TextArea;
